import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/app/AppShell";
import { AnalyticsView } from "@/components/app/Analytics";

export default function Analytics() {
  const { user } = useAuth();
  return (
    <AppShell eyebrow={`— ${(user.org_name || "").toUpperCase()}`} title="Analytics">
      <AnalyticsView endpoint="/analytics" />
    </AppShell>
  );
}
